import {
    AfterViewInit,
    Component,
    Renderer2,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'fe-snow-effect',
    templateUrl: './snow-effect.component.html',
    styleUrls: ['./snow-effect.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class SnowEffectComponent implements AfterViewInit {
    private readonly SNOWFLAKE_COUNT = 120;

    constructor(private renderer: Renderer2) {}

    ngAfterViewInit(): void {
        const container = document.querySelector('.snow');
        if (!container) return;

        for (let i = 0; i < this.SNOWFLAKE_COUNT; i++) {
            this.createSnowflake(container);
        }
    }

    private createSnowflake(container: Element) {
        const snowflake = this.renderer.createElement('span');
        this.renderer.addClass(snowflake, 'snowflake');
        snowflake.textContent = '❄';

        const size = Math.random() * 0.8 + 0.4;
        snowflake.style.fontSize = `${size}rem`;

        const startX = Math.random() * 100;
        const endX = startX + (Math.random() * 20 - 10);

        snowflake.style.setProperty('--x-start', `${startX}vw`);
        snowflake.style.setProperty('--x-end', `${endX}vw`);

        const duration = Math.random() * 8 + 5;
        const delay = Math.random() * 10;
        snowflake.style.animation = `fall ${duration}s linear ${delay}s infinite`;

        snowflake.style.opacity = `${Math.random() * 0.5 + 0.5}`;

        this.renderer.appendChild(container, snowflake);
    }
}
